module.exports = __webpack_public_path__ + "Flag-258.dcdba35dc973466bdebb40507090b3c3.svg";